<div class="sticky" style="width: 300px">
  <mat-toolbar fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="7px">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title-filter">{{ "PR.STP.COMP.TITLE_FILTERS" | pTranslate }}</span>
      <button mat-icon-button (click)="closeSignalEmit()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
  <mat-divider></mat-divider>
</div>
